export type PronunciationProblemReason = 'acronym' | 'mixed-alphanumeric' | 'number-with-unit';

export interface PronunciationProblem {
  readonly token: string;
  readonly start: number;
  readonly end: number;
  readonly reason: PronunciationProblemReason;
}

/** Finds the predictable Indonesian/English pronunciation failures before synthesis. */
export function detectPronunciationProblems(text: string): readonly PronunciationProblem[] {
  const found = new Map<string, PronunciationProblem>();
  collect(text, /\b[\p{Lu}]{2,}(?:-[\p{Lu}]{2,})*\b/gu, 'acronym', found);
  collect(text, /\b(?=[\p{L}\p{N}]*\p{L})(?=[\p{L}\p{N}]*\p{N})[\p{L}\p{N}]+\b/gu, 'mixed-alphanumeric', found);
  collect(text, /\b\d+(?:[.,]\d+)?\s?(?:kg|g|mg|km|m|cm|mm|GB|MB|KB|Hz|kHz|MHz|GHz|°C|%)(?!\p{L})/giu, 'number-with-unit', found);
  return [...found.values()].sort((a, b) => a.start - b.start || a.end - b.end);
}

function collect(
  text: string,
  pattern: RegExp,
  reason: PronunciationProblemReason,
  found: Map<string, PronunciationProblem>,
): void {
  for (const match of text.matchAll(pattern)) {
    const start = match.index;
    const token = match[0];
    found.set(`${start}:${token.length}:${reason}`, { token, start, end: start + token.length, reason });
  }
}
